import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const getSKDokumen = async (axiosInstance, dokumen, title) => {
  return await axiosInstance
    .get(`${dokumen}`, {
      responseType: "blob",
    })
    .then((response) => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    })
    .catch((error) => {
      console.error(error);
      toast.error(`GET (Transaksi) ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
};

export default getSKDokumen;
